import * as React from 'react';
import styles from './Dropdown.scss';

function Dropdown(_ref) {
  var maxHeight = _ref.maxHeight,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.dropdown,
    style: {
      maxHeight: maxHeight
    }
  }, children);
}

Dropdown.defaultProps = {
  maxHeight: undefined
};
export default Dropdown;